export const taskTypes = {
  CADDIE: 'caddie content',
  ATTACHMENT: 'attachment',
  EXTERNAL: 'external link'
}


// WEBPACK FOOTER //
// ./src/containers/pages/app/tasks/config.js